import { render } from "./indextwoblog.vue?vue&type=template&id=a44a3a16"
import script from "./indextwoblog.vue?vue&type=script&lang=js"
export * from "./indextwoblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__